import { render, staticRenderFns } from "./FbaBasketHome.vue?vue&type=template&id=2c9a2794&"
import script from "./FbaBasketHome.vue?vue&type=script&lang=js&"
export * from "./FbaBasketHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports